// Maps client routes to the lazy module Vite builds for them, so hover
// prefetching can warm the browser cache before the user clicks.
// Paths are the same specifiers used in src/routes.tsx.
const ROUTE_MODULES: Record<string, () => Promise<unknown>> = {
  '/dashboard': () => import('@/app/(dashboard)/dashboard/page'),
  '/dashboard/billing': () => import('@/app/(dashboard)/dashboard/billing/page'),
  '/dashboard/members': () => import('@/app/(dashboard)/dashboard/members/page'),
  '/dashboard/organization': () => import('@/app/(dashboard)/dashboard/organization/page'),
  '/settings': () => import('@/app/settings/page'),
  '/onboarding/company-setup': () => import('@/app/onboarding/company-setup/page'),
  '/products/productA': () => import('@/app/(dashboard)/products/productA/page'),
  '/products/productA/start': () => import('@/app/(dashboard)/products/productA/start/page'),
  '/products/productA/history': () => import('@/app/(dashboard)/products/productA/history/page'),
  '/products/productA/surveys': () => import('@/app/(dashboard)/products/productA/surveys/page'),
  '/products/productA/surveys/new': () => import('@/app/(dashboard)/products/productA/surveys/new/page'),
  '/products/productB': () => import('@/app/(dashboard)/products/productB/page'),
  '/products/productB/start': () => import('@/app/(dashboard)/products/productB/start/page'),
  '/products/productB/surveys/new': () => import('@/app/(dashboard)/products/productB/surveys/new/page'),
  '/participant/dashboard': () => import('@/app/(participant)/participant/dashboard/page'),
  '/participant/complete': () => import('@/app/(participant)/participant/complete/page'),
  '/participant/organisations': () => import('@/app/(participant)/participant/organisations/page'),
  '/admin': () => import('@/app/admin/page'),
  '/admin/users': () => import('@/app/admin/users/page'),
  '/admin/companies': () => import('@/app/admin/companies/page'),
  '/admin/productA': () => import('@/app/admin/productA/page'),
  '/admin/productA/questions': () => import('@/app/admin/productA/questions/page'),
  '/admin/productA/recommendations': () => import('@/app/admin/productA/recommendations/page'),
  '/admin/productA/assessments': () => import('@/app/admin/productA/assessments/page'),
  '/admin/productA/report-config': () => import('@/app/admin/productA/report-config/page'),
  '/admin/productA/demo-data': () => import('@/app/admin/productA/demo-data/page'),
  '/admin/productA/email-log': () => import('@/app/admin/productA/email-log/page'),
  '/admin/productB': () => import('@/app/admin/productB/page'),
  '/admin/productB/questions': () => import('@/app/admin/productB/questions/page'),
  '/admin/productB/archetypes': () => import('@/app/admin/productB/archetypes/page'),
  '/admin/productB/assessments': () => import('@/app/admin/productB/assessments/page'),
  '/admin/productB/sessions': () => import('@/app/admin/productB/sessions/page'),
  '/admin/productB/question-banks': () => import('@/app/admin/productB/question-banks/page'),
  '/admin/settings': () => import('@/app/admin/settings/page'),
  '/admin/settings/data': () => import('@/app/admin/settings/data/page'),
  '/admin/settings/email': () => import('@/app/admin/settings/email/page'),
  '/admin/settings/email/logs': () => import('@/app/admin/settings/email/logs/page'),
  '/admin/settings/email/templates': () => import('@/app/admin/settings/email/templates/page'),
  '/admin/settings/integrations': () => import('@/app/admin/settings/integrations/page'),
  '/admin/settings/llm': () => import('@/app/admin/settings/llm/page'),
  '/admin/settings/completion-messages': () => import('@/app/admin/settings/completion-messages/page'),
  '/admin/design-system': () => import('@/app/admin/design-system/page'),
  '/admin/onboarding/invitations': () => import('@/app/admin/onboarding/invitations/page'),
  '/admin/onboarding/join-requests': () => import('@/app/admin/onboarding/join-requests/page'),
  '/admin/onboarding/reports': () => import('@/app/admin/onboarding/reports/page'),
};

const prefetched = new Set<string>();

export function prefetchRoute(href: string): void {
  if (prefetched.has(href)) return;
  const loader = ROUTE_MODULES[href];
  if (!loader) return;
  prefetched.add(href);
  loader().catch(() => {
    // Prefetch failures are harmless; the real navigation will retry.
    prefetched.delete(href);
  });
}
